// import the interface


import { Auth } from '../models/auth.model';
import { AuthAction, AuthActionType } from '../actions/auth.action';
//create a dummy initial state
const initialState: Auth ={
    login:null,
    user:null
};
export function authReducer(state: Auth = initialState,action: AuthAction) {
  switch (action.type) {
    case AuthActionType.LOGIN:
      if(action.payload[0])
      {
        return {
          ...state,
          login: true,
          user:action.payload[0]
        };
      }
      return {
        ...state,
        login: false
      }
      case AuthActionType.LOGOUT:
      return {
        ...state,
        login: null,
        user:null
      };
    default:
      return state;
  }
}